<template>
    <div class="rounded-md  border-[#cccccc] py-1 px-2 border text-sm outline-[#016B00] text-[#24723b] bg-[#fff] ">
        <p class="text-xs text-[#949494]">{{ labelname }}</p>
        <input type="text" class="rounded-sm text-[#24723b] w-full text-sm outline-none font-semibold uppercase"  @input="$emit('update:modelValue', $event.target.value)">
    </div>
</template>
<script>
import { defineComponent } from 'vue';

export default defineComponent({
    props:{
        enabled:{
            type: Boolean,
            default: true,
        },
        modelValue: {
            type: String,
            default: ''
        },
        labelname:{
            type: String,
            default: "BUTTON NAME"
        },
        value:{
            type: String,
            default: "BUTTON NAME"
        },
    }
})
</script>